import styled from "styled-components";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";

const StandardToastTitleDefaultBox = styled.div`
    color: ${props => props.theme.colors.brandPrimary};
    ${({theme}) => theme.font.presets.body};
`;

const StandardToastTitleMrGreenBox = styled(StandardToastTitleDefaultBox)`
    ${({theme}) => theme.font.presets.bold};
`;

const StandardToastTitleSIBox = styled(StandardToastTitleDefaultBox)`
    color: ${props => props.theme.colors.textLight};
    ${({theme}) => theme.font.presets.bold};
`;

export const StandardToastTitleBox = styledByTheme(StandardToastTitleDefaultBox)
    .forMrGreen(StandardToastTitleMrGreenBox)
    .forMrGreenCis(StandardToastTitleMrGreenBox)
    .forSI(StandardToastTitleSIBox)
    .forSICis(StandardToastTitleSIBox)
    .apply();
